<div #modalRoute class="modal fade" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h5 class="modal-title">
          Modification de l'heure de rendez-vous
          <span
            *ngIf="event?.heureDepart && event?.heureDepart !== '..:..' && event?.heureDepart !== heureDepart"
            class="my-2 text-center text-decoration-line-through text-danger">
            {{ event?.heureDepart }}
          </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body" *ngIf="isLoaded && formule && event">
        <table id="table-modale-route" class="table table-bordered align-middle mb-0">
          <tr>
            <th class="text-end"><i class="fa fa-people-group"></i></th>
            <td><b>Heure RDV</b></td>
            <td class="text-center bg-success">
              <span class="bg-success text-white fw-bold fs-5">{{ heureDepart }}</span>
            </td>
            <td class="text-center">
              <small>arrondi de {{ heureDepartSansArrondi }}</small>
            </td>
          </tr>

          <tr>
            <th class="text-end"><i class="fa fa-shopping-cart"></i></th>
            <td><b>Chargement</b></td>
            <td class="text-center">
              {{ heureDepart }} <span class="fa fa-long-arrow-right"></span> {{ heureApresChargement }}
            </td>
            <td class="text-center">
              <small>{{ formule.loading_time }} min.</small>
            </td>
          </tr>

          <tr>
            <th class="text-end"><i class="fa fa-bell"></i></th>
            <td><b>Heure Départ</b></td>
            <td class="text-center fs-5 fw-bold">{{ heureApresChargement }}</td>
            <td></td>
          </tr>

          <tr>
            <th class="text-end"><i class="fa fa-van-shuttle"></i></th>
            <td><b>Trajet</b></td>
            <td class="text-center">
              {{ heureApresChargement }} <span class="fa fa-long-arrow-right"></span> {{ event.heureArrivee }}
            </td>
            <td class="text-center">
              <small>{{ totalTrajetMinutes }} min.<span *ngIf="formule.slow_pct"> + {{ formule.slow_pct }} %.</span></small>
            </td>
          </tr>

          <tr>
            <th class="text-end"><i class="fa fa-map-marker"></i></th>
            <td><b>Arrivée</b></td>
            <td class="text-center fs-5 fw-bold">{{ event.heureArrivee }}</td>
            <td class="text-center"><small>{{ event.ville }}</small></td>
          </tr>
        </table>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Refuser la modification</button>
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="accept()">Accepter la modification</button>
      </div>
    </div>
  </div>
</div>
